<div class="text-center">
    <mat-icon matPrefix class="my-icon">room</mat-icon>
    <p>Selecione uma sala antes.</p>
</div>